var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.605,
    height: 35.457,
    viewBox: "0 0 37.605 35.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3123.181 4954.049)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3123.181 -4954.049)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-397.416,639.225c.315-.567.535-.683,1.156-.579.7.117,1.4.232,2.095.374a4.942,4.942,0,0,1,3.871,3.953c.178.95.362,1.9.5,2.854.055.37.17.494.565.494q14.087-.019,28.173-.01c.135,0,.27-.005.4,0a.809.809,0,0,1,.787,1.115q-1.193,3.987-2.4,7.971c-.473,1.568-.943,3.137-1.423,4.7a4.045,4.045,0,0,1-4.038,3.016q-8.577.015-17.154,0a4.087,4.087,0,0,1-4.157-3.555q-1.435-8.111-2.873-16.221a3.275,3.275,0,0,0-2.71-2.73c-.625-.115-1.248-.248-1.878-.333a1.119,1.119,0,0,1-.926-.614Z",
    transform: "translate(397.416 -638.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-162.72,889.688a4.469,4.469,0,0,1-4.462-4.5,4.494,4.494,0,0,1,4.469-4.463,4.514,4.514,0,0,1,4.489,4.489A4.481,4.481,0,0,1-162.72,889.688Z",
    transform: "translate(192.38 -854.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-316.229,885.207a4.468,4.468,0,0,1-4.473,4.484,4.469,4.469,0,0,1-4.477-4.48,4.49,4.49,0,0,1,4.453-4.478A4.494,4.494,0,0,1-316.229,885.207Z",
    transform: "translate(333.085 -854.234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.21bbae9d.svg";
export { ForwardRef as ReactComponent };